import type { GgxTourDefinition } from './tour-types';

export const START_04: GgxTourDefinition = {
    key: '[START-04] Understanding the External CorridorPlatforms Website Bot',
    route: '/home',
    estimatedMinutes: 3,
    intro: {
        headline: 'Welcome to the Corridor Platforms Website Bot tour',
        subtitle:
            'An example of an External Agent pipeline: a website chatbot trained on live ' +
            "content from the Corridor Platforms website. It uses Google's Dialogflow CX and " +
            'connects to GGX, so its answers stay accurate and governed.',
    },
    outro: {
        title: "That's a wrap!",
        subtitle:
            'Whether a pipeline is custom-built or a ready-to-use external agent, the risk is ' +
            'still owned by the organization that puts it in front of customers, so governance ' +
            'and regulatory needs stay the same. Next, try it yourself: open the ' +
            'CorridorPlatforms Website Bot, look at its Dashboard for the risk metrics already ' +
            'computed, or start a Chat Session to test it live.',
        learned: [
            'The example **website bot** is built with Dialogflow CX.',
            'GGX registers it as an **External Agent** pipeline.',
            '**Evaluation, governance and monitoring** work the same as for custom pipelines.',
        ],
    },
    chapters: [
        {
            name: 'The website bot',
            blurb: 'An external agent governed in GGX',
            icon: 'map',
            steps: [2],
        },
    ],
    steps: [
        {
            title: 'Inside the website bot pipeline',
            whatHappens: 'the tour wraps up with a summary and ideas to try next.',
            icon: 'map',
            description:
                'See how GGX powers a website chatbot using live content, an external agent and ' +
                'structured evaluations, all within a governed pipeline. Watch the video, then ' +
                'click Continue.',
            video: {
                src: 'https://genguardx.ai/tours/start-04-website-bot.mp4',
                title: 'Understanding the External CorridorPlatforms Website Bot',
            },
            draftCopy: true,
        },
    ],
};
